import { ISlideTitleManager, titleChangedCallback } from '../../../core/interfaces/slide-title-manager.interface';
import { getQuerySearchParams } from '@src/slide/infrastructure/module/independent/url/param-operation';
import { IClientVarsService } from '../../../core/interfaces/client-vars-service.interface';

export class LocalSlideTitleManager implements ISlideTitleManager {
    protected slideTitle: string;
    protected offlineTitle?: string; // 离线时暂存的标题，在恢复网络时提交
    protected isUserChangeTitle = false;

    private updateTitleCallback: titleChangedCallback[] = [];

    public constructor(private clientVarsService: IClientVarsService) {
        this.slideTitle = this.clientVarsService.getClientVars().title ?? '';
        this.isUserChangeTitle = !!this.clientVarsService.getClientVars().isUserChangeTitle;
        window.document.title = this.titleWithSuffix;
        this.onTitleChanged((title) => {
            this.slideTitle = title;
            window.document.title = this.titleWithSuffix;
        });
    }

    public get title() {
        return this.slideTitle;
    }

    public get titleWithSuffix() {
        return this.getFullTitle(this.slideTitle);
    }

    /**
     * 更新 UI 标题
     * 本地编辑的标题更新行为被 native 弹窗内包了，没有暴露给前端，因此这里只需要 emit
     * @param title 标题文本
     */
    public updateTitle(title?: string) {
        this.emitTitleChanged(title ?? this.slideTitle);
    }

    // 标题实际变更后的回调
    public onTitleChanged(callback: titleChangedCallback) {
        this.updateTitleCallback.push(callback);
    }

    /**
     * 主动触发标题更新
     */
    protected emitTitleChanged(title: string) {
        this.updateTitleCallback.forEach((callback) => {
            callback(title);
        });
    }

    /**
     * 获取完整标题用于显示
     */
    private getFullTitle(title: string) {
        const localFilePath = getQuerySearchParams('localFilePath');
        let titleSuffix = '.pptx';
        if (localFilePath.includes('.')) {
            titleSuffix = `.${localFilePath.split('.').pop()}`;
        }
        return `${title}${titleSuffix}`;
    }
}
